
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { CheckCircle, PartyPopper } from 'lucide-react';
import confetti from 'canvas-confetti';

const ExamComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const savedState = location.state || JSON.parse(sessionStorage.getItem("examCompletion") || '{}');
const examName = savedState.examName || '';
const examCompleted = savedState.examCompleted ?? false;

  
  useEffect(() => {
    // Redirect to dashboard if accessed directly without exam completion
    if (!examCompleted) {
      navigate('/candidate');
    }
    
    
    // Show confetti effect on successful exam completion
    const duration = 3000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

    // Launch confetti effect
    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
      
      if (timeLeft <= 0) {
        return clearInterval(interval);
      }
      
      const particleCount = 50 * (timeLeft / duration);
      confetti({
        ...defaults,
        particleCount,
        origin: { x: Math.random(), y: Math.random() * 0.5 }
      });
    }, 250);
    
    const timeout = setTimeout(() => {
    navigate('/candidate');
  }, 5000);

    return () => {
    clearInterval(interval);
    clearTimeout(timeout); 
  };
}, [examCompleted, navigate]);

// Clear saved exam completion after showing
sessionStorage.removeItem("examCompletion");


  return (
    <div className="container mx-auto px-4 py-16 max-w-3xl">
      <Card className="p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <CheckCircle className="h-20 w-20 text-green-500" />
            <PartyPopper className="absolute -top-2 -right-2 h-8 w-8 text-amber-500 rotate-12" />
          </div>
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Exam Completed</h1>
        
        <p className="text-xl mb-8">
          You have successfully completed the {examName || 'exam'}!
        </p>
        
        <div className="mb-8 text-gray-700">
          <p className="mb-4">
            Thank you for completing the examination. Your responses have been submitted successfully.
          </p>
          <p className="mb-4">
            Results will be available soon. You will be notified via email once your results are ready.
          </p>
          <p>
            A detailed report of your performance will be shared with you by the administrator.
          </p>
        </div>
        
        <div className="flex justify-center">
          <Button 
            size="lg"
            onClick={() => navigate('/candidate')}
          >
            Return to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ExamComplete;
